export default class Styles {
  static get ZINDEX() {
    return {
      NAVBAR: 2001,
      COVER_CENTER: 100,
      SECTION_CONTENT: 100,
    };
  }
  static get SECTION_HEIGHTS() {
    return {
      COVER: 2.4,
      COVER_MOBILE: 1.5,
      VIDEO: 2,
      MAIN_MENU: 2,
      ABOUT_US: 3,
      WORK: 3,
      WORK_MOBILE: 2,
      SERVICE_COVER: 1,
      SERVICE_DETAIL: 4,
      SERVICE_COVER_MOBILE: 1.9,
      SERVICES: "500vh",
      WHY_US: 2,
      CONTACT: "100vh",
      TEAM: "auto",
      MIN_CONTAINER_HEIGHT: 600,
      FULL_HEIGHT: "100vh",
    };
  }
  static get FONTS() {
    return {
      FONT_REGULAR: "var(--font-regular)",
      FONT_LIGHT: "var(--font-light)",
      FONT_SEMI_BOLD: "var(--font-semi-bold)",
      FONT_BOLD: "var(--font-bold)",
      FONT_EXTRA_BOLD: "var(--font-extra-bold)",
      FONT_BLACK: "var(--font-black)",
      FONT_TITLE: "var(--font-title)",
      FONT_TITLE_LIGHT: "var(--font-title-light)",
      FONT_TITLE_BOLD: "var(--font-title-bold)",
    };
  }
}
